<div id="sh-switch-org-container">
	<prism-org-switcher (click)="openChangeOrganization()">
		<prism-profile-image
			id="sh-switch-org-profile-image"
			slot="profile"
			[firstName]="initials().firstInitial"
			[lastName]="initials().secondInitial"
		></prism-profile-image>
		<span id="sh-switch-org-default-org-name-div">{{ organizationName() }}</span>
	</prism-org-switcher>
	<hr class="prism-divider" />
</div>
